import React, { useState } from 'react';
import { Search, MapPin, Users, Calendar, Anchor } from 'lucide-react';
import './SearchSection.css';
import sectiontwo from '../assets/images/web-search.png';
import sectionMobile from '../assets/images/search-mobile.png';
const SearchSection = ({ onSearch }) => {


  return (
    <section className="search-section" >
      {/* <div className="search-section-content">
        <div className="search-section-content-left">
          <h1>Find Your Perfect Yacht</h1>
          <p>Search for your perfect yacht by location, price, and more.</p>
        </div>
      </div> */}
    </section>
  );
};

export default SearchSection; 